import { render, staticRenderFns } from "./SizeSection.vue?vue&type=template&id=564aad9c&scoped=true"
import script from "./SizeSection.vue?vue&type=script&lang=js"
export * from "./SizeSection.vue?vue&type=script&lang=js"
import style0 from "./SizeSection.vue?vue&type=style&index=0&id=564aad9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564aad9c",
  null
  
)

export default component.exports